var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('cwp-modal',{model:{value:(_vm.modal),callback:function ($$v) {_vm.modal=$$v},expression:"modal"}},[_c('div',{staticClass:"cwp-html-content",domProps:{"innerHTML":_vm._s(_vm.container.modalContent)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }